// import React, { useState, useEffect, useMemo } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   AssignTable,
//   Button,
//   FormFieldSet,
//   InfoCardTwo,
//   PageHeader,
//   PageTitle,
// } from "../../../../components";
// import {
//   getFollowAssignDataStart,
//   saveShuffleStart,
// } from "../../../../redux/slices/compaigns/compaignsSlice";
// import dayjs from "dayjs";

// const FollowUpAssign = () => {
//   const dispatch = useDispatch();
//   const followData = useSelector(
//     (state) => state.compaigns.assignData.followData
//   );
//   const { user } = useSelector((state) => state.auth);

//   const [selectedDate, setSelectedDate] = useState(
//     dayjs().format("YYYY-MM-DD")
//   );
//   const [selectedShuffleType, setSelectedShuffleType] = useState("raToBdm");
//   const [assignmentOutput, setAssignmentOutput] = useState([]);

//   const shuffleTypeMap = {
//     raToBdm: 1,
//     equally: 2,
//     range: 3,
//   };

//   // Fetch follow-up assignments
//   const fetchFollowAssignments = (date) => {
//     const filterDate = date || dayjs().format("YYYY-MM-DD");
//     const filter = { date: { type: "NONE", value: filterDate } };
//     dispatch(
//       getFollowAssignDataStart({
//         coll: "Shuffle",
//         lim: 10,
//         pg: 1,
//         ref: "Jobwithcompany Propects",
//         extret: "uiid firstName email lastName level",
//         fil: JSON.stringify(filter),
//         sort: JSON.stringify({ uiid: -1 }),
//         extincl: JSON.stringify(["uiid"]),
//       })
//     );
//   };

//   useEffect(() => {
//     fetchFollowAssignments(selectedDate);
//   }, [selectedDate, dispatch]);

//   const handleDateChange = (date) => {
//     const formattedDate = dayjs(date).format("YYYY-MM-DD");
//     setSelectedDate(formattedDate);
//   };

//   // Pick latest version for selected date
//   const latestDataForDate = useMemo(() => {
//     if (!followData || !Array.isArray(followData)) return null;
//     const filtered = followData.filter((item) => item.date === selectedDate);
//     if (!filtered.length) return null;
//     return filtered.sort((a, b) => (b.version || 0) - (a.version || 0))[0];
//   }, [followData, selectedDate]);

//   // Transform data for AssignTable (handle null BDM/RA)
//   // const transformedData = useMemo(() => {
//   //   if (!latestDataForDate) return { bdmList: [], teamList: [] };
//   //   const bdms = [];
//   //   const teams = [];

//   //   latestDataForDate.shuffle.forEach((shuffleItem, bdmIndex) => {
//   //     const bdmObj = shuffleItem.BdmId || {
//   //       uiid: `bdm-${bdmIndex}`,
//   //       firstName: "Unknown",
//   //       lastName: "",
//   //       email: { primary: "" },
//   //     };

//   //     if (!bdms.some((b) => b.id === bdmObj.uiid)) {
//   //       bdms.push({
//   //         id: bdmObj.uiid,
//   //         name: `${bdmObj.firstName} ${bdmObj.lastName}`.trim(),
//   //         email: bdmObj.email?.primary || "",
//   //       });
//   //     }

//   //     shuffleItem.assignedProspectData?.forEach((p, idx) => {
//   //       const raObj = p.raId || {
//   //         uiid: `ra-${bdmObj.uiid}-${idx}`,
//   //         firstName: "RA",
//   //         level: 1,
//   //       };

//   //       let designation = "fresher";
//   //       if (raObj.level === 3) designation = "senior";
//   //       else if (raObj.level === 2) designation = "junior";

//   //       teams.push({
//   //         id: raObj.uiid,
//   //         key: `team-${bdmObj.uiid}-${idx}`,
//   //         name: raObj.firstName,
//   //         company: p.jobId?.companyId?.[0]?.name || "",
//   //         location: p.jobId?.location?.city || "",
//   //         prospectCount: p.jobId?.prospectIds?.length || 0,
//   //         assignedTo: bdmObj.uiid,
//   //         designation,
//   //         jobProspects:
//   //           p.jobId?.prospectIds?.map((pid) => ({
//   //             jobId: p.jobId.uiid || null,
//   //             prospectId: pid || null,
//   //           })) || [],
//   //       });
//   //     });
//   //   });

//   //   return { bdmList: bdms, teamList: teams };
//   // }, [latestDataForDate]);
//   // Transform data for AssignTable (group by RA properly)
//   // const transformedData = useMemo(() => {
//   //   if (!latestDataForDate) return { bdmList: [], teamList: [] };

//   //   const bdms = [];
//   //   const raMap = new Map();

//   //   latestDataForDate.shuffle.forEach((shuffleItem, bdmIndex) => {
//   //     const bdmObj = shuffleItem.BdmId || {
//   //       uiid: `bdm-${bdmIndex}`,
//   //       firstName: "Unknown",
//   //       lastName: "",
//   //       email: { primary: "" },
//   //     };

//   //     // Push BDM if not exists
//   //     if (!bdms.some((b) => b.id === bdmObj.uiid)) {
//   //       bdms.push({
//   //         id: bdmObj.uiid,
//   //         name: `${bdmObj.firstName} ${bdmObj.lastName}`.trim(),
//   //         email: bdmObj.email?.primary || "",
//   //       });
//   //     }

//   //     shuffleItem.assignedProspectData?.forEach((p, idx) => {
//   //       const raObj = p.raId || {
//   //         uiid: `ra-${bdmObj.uiid}-${idx}`,
//   //         firstName: "RA",
//   //         level: 1,
//   //       };

//   //       let designation = "fresher";
//   //       if (raObj.level === 3) designation = "senior";
//   //       else if (raObj.level === 2) designation = "junior";

//   //       // If RA already exists, merge prospects
//   //       if (raMap.has(raObj.uiid)) {
//   //         const existing = raMap.get(raObj.uiid);
//   //         existing.prospectCount += p.jobId?.prospectIds?.length || 0;
//   //         existing.jobProspects.push(
//   //           ...(p.jobId?.prospectIds?.map((pid) => ({
//   //             jobId: p.jobId.uiid || null,
//   //             prospectId: pid || null,
//   //           })) || [])
//   //         );
//   //       } else {
//   //         raMap.set(raObj.uiid, {
//   //           id: raObj.uiid,
//   //           key: `team-${bdmObj.uiid}-${idx}`,
//   //           name: raObj.firstName,
//   //           company: p.jobId?.companyId?.[0]?.name || "",
//   //           location: p.jobId?.location?.city || "",
//   //           prospectCount: p.jobId?.prospectIds?.length || 0,
//   //           assignedTo: bdmObj.uiid,
//   //           designation,
//   //           jobProspects:
//   //             p.jobId?.prospectIds?.map((pid) => ({
//   //               jobId: p.jobId.uiid || null,
//   //               prospectId: pid || null,
//   //             })) || [],
//   //         });
//   //       }
//   //     });

//   //     // shuffleItem.assignedProspectData?.forEach((p, idx) => {
//   //     //   const raObj = p.raId || {
//   //     //     uiid: `ra-${bdmObj.uiid}-${idx}`,
//   //     //     firstName: "RA",
//   //     //     level: 1,
//   //     //   };

//   //     //   let designation = "fresher";
//   //     //   if (raObj.level === 3) designation = "senior";
//   //     //   else if (raObj.level === 2) designation = "junior";

//   //     //   if (!raMap.has(raObj.uiid)) {
//   //     //     raMap.set(raObj.uiid, {
//   //     //       id: raObj.uiid,
//   //     //       key: `team-${bdmObj.uiid}-${idx}`,
//   //     //       name: raObj.firstName,
//   //     //       assignedTo: bdmObj.uiid,
//   //     //       designation,
//   //     //       prospectCount: 0,
//   //     //       jobProspects: [],
//   //     //     });
//   //     //   }

//   //     //   const existing = raMap.get(raObj.uiid);

//   //     //   // count only if prospectId is present
//   //     //   if (p.prospectId) {
//   //     //     existing.prospectCount += 1;
//   //     //     existing.jobProspects.push({
//   //     //       jobId: p.jobId,
//   //     //       prospectId: p.prospectId,
//   //     //     });
//   //     //   }
//   //     // });
//   //   });

//   //   return { bdmList: bdms, teamList: Array.from(raMap.values()) };
//   // }, [latestDataForDate]);
//   const transformedData = useMemo(() => {
//     if (!latestDataForDate) return { bdmList: [], teamList: [] };

//     const bdms = [];
//     const raMap = new Map();

//     latestDataForDate.shuffle.forEach((shuffleItem, bdmIndex) => {
//       const bdmObj = shuffleItem.BdmId || {
//         uiid: `bdm-${bdmIndex}`,
//         firstName: "Unknown",
//         lastName: "",
//         email: { primary: "" },
//       };

//       if (!bdms.some((b) => b.id === bdmObj.uiid)) {
//         bdms.push({
//           id: bdmObj.uiid,
//           name: `${bdmObj.firstName} ${bdmObj.lastName}`.trim(),
//           email: bdmObj.email?.primary || "",
//         });
//       }

//       shuffleItem.assignedProspectData?.forEach((p, idx) => {
//         const raObj = p.raId || {
//           uiid: `ra-${bdmObj.uiid}-${idx}`,
//           firstName: "RA",
//           level: 1,
//         };

//         let designation = "fresher";
//         if (raObj.level === 3) designation = "senior";
//         else if (raObj.level === 2) designation = "junior";

//         const prospectEntries =
//           p.jobId?.prospectIds?.map((pid) => ({
//             jobId: p.jobId.uiid || null,
//             prospectId: pid || null,
//           })) || [];

//         if (raMap.has(raObj.uiid)) {
//           const existing = raMap.get(raObj.uiid);

//           // Add only new prospects
//           prospectEntries.forEach((jp) => {
//             if (
//               jp.prospectId &&
//               !existing.jobProspects.some(
//                 (existingJP) => existingJP.prospectId === jp.prospectId
//               )
//             ) {
//               existing.jobProspects.push(jp);
//             }
//           });

//           existing.prospectCount = existing.jobProspects.length; // update count
//         } else {
//           raMap.set(raObj.uiid, {
//             id: raObj.uiid,
//             key: `team-${bdmObj.uiid}-${idx}`,
//             name: raObj.firstName,
//             company: p.jobId?.companyId?.[0]?.name || "",
//             location: p.jobId?.location?.city || "",
//             prospectCount: prospectEntries.length,
//             assignedTo: bdmObj.uiid,
//             designation,
//             jobProspects: prospectEntries,
//           });
//         }
//       });
//     });

//     return { bdmList: bdms, teamList: Array.from(raMap.values()) };
//   }, [latestDataForDate]);

//   const memoizedData = useMemo(() => transformedData, [transformedData]);

//   // Initialize assignmentOutput so table data persists
//   useEffect(() => {
//     if (!memoizedData.bdmList.length) {
//       setAssignmentOutput([]); // clear when no data found
//       return;
//     }
//     const initialOutput = memoizedData.bdmList.map((bdm) => ({
//       bdm,
//       teams: {
//         senior: memoizedData.teamList.filter(
//           (t) => t.assignedTo === bdm.id && t.designation === "senior"
//         ),
//         junior: memoizedData.teamList.filter(
//           (t) => t.assignedTo === bdm.id && t.designation === "junior"
//         ),
//         fresher: memoizedData.teamList.filter(
//           (t) => t.assignedTo === bdm.id && t.designation === "fresher"
//         ),
//       },
//     }));
//     setAssignmentOutput(initialOutput);
//   }, [memoizedData]);

//   const { bdmList, teamList } = memoizedData;

//   const totalEmails = teamList.reduce(
//     (sum, t) => sum + (t.prospectCount || 0),
//     0
//   );

//   const designationCounts = teamList.reduce(
//     (acc, t) => {
//       if (t.designation === "senior") acc.senior += 1;
//       else if (t.designation === "junior") acc.junior += 1;
//       else acc.fresher += 1;
//       return acc;
//     },
//     { senior: 0, junior: 0, fresher: 0 }
//   );

//   // Save payload same as Assign
//   const handleSave = () => {
//     if (!assignmentOutput.length) {
//       console.warn("No assignments to save for this date.");
//       return;
//     }

//     const payload = {
//       coll: "Shuffle",
//       payload: {
//         date: selectedDate,
//         shuffleType: shuffleTypeMap[selectedShuffleType] || 1,
//         addedBy: Number(user.data.uiid),
//         version: 1,
//         shuffle: assignmentOutput.map((a) => ({
//           BdmId: a.bdm.id,
//           assignedProspectData: [
//             ...(a.teams.senior || []),
//             ...(a.teams.junior || []),
//             ...(a.teams.fresher || []),
//           ].flatMap((team) =>
//             (team.jobProspects || []).length
//               ? team.jobProspects.map((jp) => ({
//                   raId: team.id,
//                   jobId: jp.jobId || null,
//                   prospectId: jp.prospectId || null,
//                 }))
//               : [{ raId: team.id, jobId: null, prospectId: null }]
//           ),
//         })),
//       },
//     };

//     dispatch(saveShuffleStart(payload));
//   };

//   return (
//     <div className="px-5 py-3">
//       <PageHeader
//         Section={
//           <div className="flex items-center gap-4">
//             <PageTitle title="Follow-Up Assign RA to BDMs" tag="h5" />
//           </div>
//         }
//         RightSection={
//           <div className="flex items-center gap-5">
//             <FormFieldSet
//               type="datepicker"
//               title="Select Date"
//               placeholder="Select Date"
//               value={selectedDate}
//               onChange={handleDateChange}
//             />
//             <FormFieldSet
//               type="select"
//               title="Shuffle Type"
//               placeholder="Select Shuffle"
//               value={selectedShuffleType}
//               options={[
//                 { label: "RA to BDM", value: "raToBdm" },
//                 { label: "Equally", value: "equally" },
//                 { label: "Range", value: "range" },
//               ]}
//               onChange={(val) => setSelectedShuffleType(val)}
//             />
//           </div>
//         }
//       />

//       <div className="grid grid-cols-5 gap-8 my-4">
//         <InfoCardTwo
//           title="Total BDM's"
//           value={bdmList.length}
//           icon="business_center"
//         />
//         <InfoCardTwo
//           title="Senior RA"
//           value={designationCounts.senior}
//           icon="business_center"
//         />
//         <InfoCardTwo
//           title="Junior RA"
//           value={designationCounts.junior}
//           icon="business_center"
//         />
//         <InfoCardTwo
//           title="Fresher RA"
//           value={designationCounts.fresher}
//           icon="business_center"
//         />
//         <InfoCardTwo
//           title="Total Prospects"
//           value={totalEmails}
//           icon="business_center"
//         />
//       </div>

//       <div className="w-full overflow-auto">
//         {assignmentOutput.length > 0 ? (
//           <AssignTable data={memoizedData} output={setAssignmentOutput} />
//         ) : (
//           <p className="text-center text-gray-500 py-4">
//             No assignments found for this date.
//           </p>
//         )}
//       </div>

//       <div className="flex justify-end my-10">
//         <Button title="Save" onClick={handleSave} />
//       </div>
//     </div>
//   );
// };

// export default FollowUpAssign;

import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AssignTable,
  Backdrop,
  Button,
  FormFieldSet,
  InfoCardNewAdv,
  InfoCardTwo,
  InfoWrapper,
  LogoLoader,
  PageHeader,
  PageTitle,
  showToast,
} from "../../../../components";
import {
  getFollowAssignDataStart,
  getAssignDataStart,
  saveShuffleStart,
} from "../../../../redux/slices/compaigns/compaignsSlice";
import dayjs from "dayjs";
import { formatWords2 } from "../../../../utils/stringUtils";

const FollowUpAssign = () => {
  const dispatch = useDispatch();
  const followData = useSelector(
    (state) => state.compaigns.assignData.followData
  );
  const { user } = useSelector((state) => state.auth);
  const assignData = useSelector((state) => state.compaigns?.assignData?.data);
  const { loading } = useSelector((state) => state?.compaigns);

  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("YYYY-MM-DD")
  );
  const [selectedShuffleType, setSelectedShuffleType] = useState("default");
  const [savedShuffleType, setSavedShuffleType] = useState("");
  const [assignmentOutput, setAssignmentOutput] = useState([]);
  const [min, setMin] = useState("");
  const [max, setMax] = useState("");
  const [validatedRange, setValidatedRange] = useState({
    min: null,
    max: null,
  });

  // console.log("followData: ", savedShuffleType !== selectedShuffleType, savedShuffleType, selectedShuffleType, followData, assignData)

  const handleAssignmentOutput = (assignments) => {
    setAssignmentOutput(assignments);
  };

  const shuffleTypeMap = {
    raToBdm: 1,
    equally: 2,
    range: 3,
  };

  // Fetch follow-up assignments
  const fetchFollowAssignments = (date) => {
    const filterDate = date || dayjs().format("YYYY-MM-DD");
    const filter = { date: { type: "NONE", value: filterDate } };
    dispatch(
      getFollowAssignDataStart({
        coll: "Shuffle",
        lim: 1,
        pg: 1,
        ref: "Jobwithcompany Propects",
        extret: "uiid firstName email lastName level",
        fil: JSON.stringify(filter),
        sort: JSON.stringify({ uiid: -1 }),
        extincl: JSON.stringify(["uiid"]),
      })
    );
  };

  const isValidNumber = (value) =>
    value !== "" && !isNaN(value) && isFinite(Number(value));

  const handleApplyRange = () => {
    if (min === "" || max === "") {
      showToast("Both Min and Max values are required", "error");
      return;
    }
    if (!isValidNumber(min) || !isValidNumber(max)) {
      showToast("Min and Max must be valid numbers", "error");
      return;
    }
    if (Number(min) > Number(max)) {
      showToast("Min value cannot be greater than Max value", "error");
      return;
    }

    setValidatedRange({ min: Number(min), max: Number(max) });
  };

  useEffect(() => {
    fetchFollowAssignments(selectedDate);
  }, []);

  useEffect(() => {
    if (savedShuffleType !== "") {
      if (savedShuffleType !== selectedShuffleType) {
        console.log(
          "Fetching assign data for date:",
          savedShuffleType,
          selectedShuffleType
        );
        fetchAssignData(selectedDate);
      } else {
        console.log(
          "Fetching follow-up assignments for date:",
          savedShuffleType,
          selectedShuffleType
        );
        fetchFollowAssignments(selectedDate);
      }
    }
  }, [selectedDate, selectedShuffleType, dispatch]);

  const handleDateChange = (date) => {
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    setSelectedDate(formattedDate);
  };

  useEffect(() => {
    if (followData) {
      if (followData[0]?.shuffleType) {
        if (followData[0].shuffleType === 1) {
          setSavedShuffleType("default");
          setSelectedShuffleType("default");
        } else if (followData[0].shuffleType === 2) {
          setSavedShuffleType("equally");
          setSelectedShuffleType("equally");
        } else {
          setSavedShuffleType("range");
          setSelectedShuffleType("range");
        }
      }
    }
  }, [followData]);

  // Pick latest version for selected date
  const latestDataForDate = useMemo(() => {
    if (!followData || !Array.isArray(followData)) return null;
    const filtered = followData.filter((item) => item.date === selectedDate);
    if (!filtered.length) return null;

    return filtered.sort((a, b) => (b.version || 0) - (a.version || 0))[0];
  }, [followData, selectedDate]);

  // Transform data for AssignTable
  const transformedData = useMemo(() => {
    if (!latestDataForDate) return { bdmList: [], teamList: [] };

    const bdms = [];
    // const raMap = new Map();
    const raMap = [];

    latestDataForDate.shuffle.forEach((shuffleItem, bdmIndex) => {
      const bdmObj = shuffleItem.BdmId || {
        uiid: `bdm-${bdmIndex}`,
        firstName: "Unknown",
        lastName: "",
        email: { primary: "" },
      };

      // Add BDM if not already in list
      if (!bdms.some((b) => b.id === bdmObj.uiid)) {
        bdms.push({
          id: bdmObj.uiid,
          name: `${formatWords2(bdmObj.firstName)} ${formatWords2(bdmObj.lastName)}`.trim(),
          email: bdmObj.email?.primary || "",
        });
      }

      // Loop through assigned RA data
      shuffleItem.assignedProspectData?.forEach((p, idx) => {
        const raObj = p.raId || {
          uiid: `ra-${bdmObj.uiid}-${idx}`,
          firstName: "RA",
          level: 1,
        };

        // Updated level logic
        const level = Number(raObj.level) || 1;
        let designation = "fresher";
        if ([3, 4, 5].includes(level)) designation = "senior";
        else if (level === 2) designation = "junior";

        // const prospectEntries =
        //   p.jobId?.prospectIds?.map((pid) => ({
        //     jobId: p.jobId.uiid || null,
        //     prospectId: pid || null,
        //   })) || [];

        // const validProspects = shuffleItem.assignedProspectData?.filter(p => p.prospectId !== null) || [];

        // const prospectEntries = p.prospectId !== null ? validProspects.map((prop => ({
        //         jobId: prop.prospectId.jobIds?.[0], prospectId: prop.prospectId.uiid
        //       }))) : []

        const prospectEntries =
          p.prospectId !== null
            ? [
                {
                  jobId: p.prospectId.jobIds?.[0],
                  prospectId: p.prospectId.uiid,
                },
              ]
            : [];

        // if (raMap.has(raObj.uiid)) {
        //   const existing = raMap.get(raObj.uiid);
        //   prospectEntries.forEach((jp) => {
        //     if (
        //       jp.prospectId &&
        //       !existing.jobProspects.some(
        //         (existingJP) => existingJP.prospectId === jp.prospectId
        //       )
        //     ) {
        //       existing.jobProspects.push(jp);
        //     }
        //   });
        //   existing.prospectCount = existing.jobProspects.length;
        // } else {
        //   raMap.set(raObj.uiid, {
        //     id: raObj.uiid,
        //     key: `team-${bdmObj.uiid}-${idx}`,
        //     name: raObj.firstName,
        //     company: p.jobId?.companyId?.[0]?.name || "",
        //     location: p.jobId?.location?.city || "",
        //     prospectCount: prospectEntries.length,
        //     assignedTo: bdmObj.uiid,
        //     designation,
        //     jobProspects: prospectEntries,
        //   });
        // }

        raMap.push({
          id: raObj.uiid,
          key: `team-${bdmObj.uiid}-${idx}`,
          name: formatWords2(raObj.firstName),
          company: formatWords2(p.jobId?.companyId?.[0]?.name || ""),
          location: formatWords2(p.jobId?.location?.city || ""),
          prospectCount: prospectEntries.length,
          assignedTo: bdmObj.uiid,
          designation,
          jobProspects: prospectEntries,
        });
      });
    });

    return { bdmList: bdms, teamList: Array.from(raMap.values()) };
  }, [latestDataForDate]);

  const memoizedData = useMemo(() => transformedData, [transformedData]);

  const fetchAssignData = (date) => {
    const action = {
      coll: "Job",
      queryMode: "AG_ASSIGN",
      useAggregate: true,
      fil: JSON.stringify({ dates: { type: "AG_ASSIGN", value: date } }),
    };
    dispatch(getAssignDataStart(action));
  };

  const transformedAssignData = assignData
    ? {
        bdmList: assignData.map((bdm) => ({
          id: bdm.uiid,
          name: `${bdm.firstName} ${bdm.lastName}`,
          email: bdm.email?.primary || "",
        })),
        teamList: assignData.flatMap((bdm) =>
          bdm.raData.flatMap((category) =>
            (category.users || []).map((user) => ({
              id: `${user.uiid}`,
              name: user.firstName,
              designation:
                category.category === 1
                  ? "fresher"
                  : category.category === 2
                  ? "junior"
                  : "senior",
              prospectCount: user.jobs?.reduce(
                (sum, job) => sum + (job.prospectIds?.length || 0),
                0
              ),
              assignedTo: bdm.uiid,
              jobProspects:
                user.jobs?.flatMap((job) =>
                  (job.prospectIds || []).map((pid) => ({
                    jobId: job.uiid ?? null,
                    prospectId: pid ?? null,
                  }))
                ) || [],
            }))
          )
        ),
      }
    : null;

  const memoizedAssignData = React.useMemo(
    () => transformedAssignData || [],
    [transformedAssignData]
  );

  // Initialize assignment output
  useEffect(() => {
    if (!memoizedData.bdmList.length) {
      setAssignmentOutput([]);
      return;
    }

    const initialOutput = memoizedData.bdmList.map((bdm) => ({
      bdm,
      teams: {
        senior: memoizedData.teamList.filter(
          (t) => t.assignedTo === bdm.id && t.designation === "senior"
        ),
        junior: memoizedData.teamList.filter(
          (t) => t.assignedTo === bdm.id && t.designation === "junior"
        ),
        fresher: memoizedData.teamList.filter(
          (t) => t.assignedTo === bdm.id && t.designation === "fresher"
        ),
      },
    }));

    setAssignmentOutput(initialOutput);
  }, [memoizedData]);

  const { bdmList, teamList } =
    savedShuffleType === ""
      ? memoizedData
      : savedShuffleType !== selectedShuffleType
      ? memoizedAssignData
      : memoizedData;

  const totalEmails = teamList.reduce(
    (sum, t) => sum + (t.prospectCount || 0),
    0
  );

  const designationCounts = teamList.reduce(
    (acc, t) => {
      if (t.designation === "senior") acc.senior += 1;
      else if (t.designation === "junior") acc.junior += 1;
      else acc.fresher += 1;
      return acc;
    },
    { senior: 0, junior: 0, fresher: 0 }
  );

  // Save assignments
  // const handleSave = () => {
  //   if (!assignmentOutput.length) {
  //     console.warn("No assignments to save for this date.");
  //     return;
  //   }

  //   console.log("assignmentOutput: ", assignmentOutput)

  //   const payload = {
  //     coll: "Shuffle",
  //     payload: {
  //       date: selectedDate,
  //       shuffleType: shuffleTypeMap[selectedShuffleType] || 1,
  //       addedBy: Number(user.data.uiid),
  //       version: 1,
  //       shuffle: assignmentOutput.map((a) => ({
  //         BdmId: a.bdm.id,
  //         assignedProspectData: [
  //           ...(a.teams.senior || []),
  //           ...(a.teams.junior || []),
  //           ...(a.teams.fresher || []),
  //         ].flatMap((team) =>
  //           (team.jobProspects || []).length
  //             ? team.jobProspects.map((jp) => ({
  //                 raId: team.id,
  //                 jobId: jp.jobId || null,
  //                 prospectId: jp.prospectId || null,
  //               }))
  //             : [{ raId: team.id, jobId: null, prospectId: null }]
  //         ),
  //       })),
  //     },
  //   };

  //   console.log("Dispatching FollowUp save payload:", payload);
  //   dispatch(saveShuffleStart(payload));
  // };

  const handleSave = () => {
    if (!assignmentOutput?.length) {
      console.warn("No assignments to save");
      return;
    }

    let prospectsList = [];

    const shuffleData = assignmentOutput.map(({ bdm, totalEmails, teams }) => {
      const assignedProspectData = Object.values(teams || {})
        .flat()
        .flatMap((team) => {
          const prospects =
            team.jobProspects?.map((jp) => ({
              raId: Number(team.id),
              jobId: Number(jp.jobId) || null,
              prospectId: Number(jp.prospectId) || null,
            })) || [];

          if (prospects.length) prospectsList.push(...prospects);
          return [{ raId: Number(team.id), jobId: null, prospectId: null }];
        });

      return {
        BdmId: Number(bdm.id),
        totalEmails: Number(totalEmails),
        assignedProspectData,
      };
    });

    const apiPayload = {
      coll: "Shuffle",
      payload: {
        date: new Date().toISOString(),
        shuffleType: shuffleTypeMap[selectedShuffleType] || 1,
        addedBy: Number(user.data.uiid),
        version: 1,
        shuffle: shuffleData.map(
          ({ BdmId, totalEmails, assignedProspectData }) => ({
            BdmId,
            assignedProspectData:
              totalEmails > 0
                ? [
                    ...assignedProspectData,
                    ...prospectsList.splice(0, totalEmails),
                  ]
                : assignedProspectData,
          })
        ),
      },
    };

    console.log("apiPayload: ", apiPayload);

    dispatch(saveShuffleStart(apiPayload));
  };

  return (
    <div className="px-5 py-3">
      <PageHeader
        Section={
          <div className="flex items-center gap-4">
            <PageTitle title="Follow-Up Assign RA to BDMs" tag="h5" />
          </div>
        }
        RightSection={
          <div className="flex items-center gap-5">
            <FormFieldSet
              type="datepicker"
              title="Select Date"
              placeholder="Select Date"
              value={selectedDate}
              onChange={handleDateChange}
              shadow={true}
            />
            <FormFieldSet
              type="select"
              title="Shuffle Type"
              placeholder="Select Shuffle"
              value={selectedShuffleType}
              options={[
                { label: "RA to BDM", value: "default" },
                { label: "Equally", value: "equally" },
                { label: "Range", value: "range" },
              ]}
              shadow={true}
              onChange={(val) => setSelectedShuffleType(val)}
            />
            {selectedShuffleType === "range" && (
              <div className="flex items-end gap-2">
                <div className="w-[120px]">
                  <FormFieldSet
                    title="Enter Range"
                    shadow={true}
                    placeholder="Min"
                    value={min}
                    onChange={(value) => setMin(value)}
                  />
                </div>
                <div className="w-[120px]">
                  <FormFieldSet
                    title=""
                    placeholder="Max"
                    shadow={true}
                    value={max}
                    onChange={(value) => setMax(value)}
                  />
                </div>
                <Button
                  title={"Apply"}
                  variant="outlined"
                  onClick={handleApplyRange}
                />
              </div>
            )}
          </div>
        }
      />
      <div className="mt-3">
      <InfoWrapper className="min-w-60!">
        <InfoCardNewAdv
          title="Total BDM's"
          value={bdmList.length}
          icon="business_center"
          layout="option8"
        />
        <InfoCardNewAdv
          title="Senior RA"
          value={designationCounts.senior}
          icon="business_center"
          layout="option8"
        />
        <InfoCardNewAdv
          title="Junior RA"
          value={designationCounts.junior}
          icon="business_center"
          layout="option8"
        />
        <InfoCardNewAdv
          title="Fresher RA"
          value={designationCounts.fresher}
          icon="business_center"
          layout="option8"
        />
        <InfoCardNewAdv
          title="Total Prospects"
          value={totalEmails}
          icon="business_center"
          layout="option8"
        />
      </InfoWrapper>
</div>
      <div className="w-full overflow-auto">
        {/* {assignmentOutput.length > 0 ? ( */}
        {/* { hasData ? ( */}
        <AssignTable
          key={JSON.stringify(
            savedShuffleType === ""
              ? memoizedData
              : savedShuffleType !== selectedShuffleType
              ? memoizedAssignData
              : memoizedData
          )}
          // data={memoizedData}
          data={
            savedShuffleType === ""
              ? memoizedData
              : savedShuffleType !== selectedShuffleType
              ? memoizedAssignData
              : memoizedData
          }
          type={
            savedShuffleType === ""
              ? "followup"
              : savedShuffleType !== selectedShuffleType
              ? "assign"
              : "followup"
          }
          // type="followup"
          output={handleAssignmentOutput}
          shuffleType={selectedShuffleType}
          minEmails={validatedRange.min}
          maxEmails={validatedRange.max}
        />
        {/* ) : (
          <p className="text-center text-gray-500 py-4">
            No assignments found for this date.
          </p>
        )} */}
      </div>

      <div className="flex justify-end my-10">
        <Button title="Save" onClick={handleSave} />
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default FollowUpAssign;
